import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const r = () => /* @__PURE__ */ s.jsx("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ s.jsx(
  "path",
  {
    d: "M22.5 12c0 2.775 -0.45 5.025 -1.05 5.025S20.4 14.775 20.4 12s0.45 -5.025 1.05 -5.025S22.5 9.225 22.5 12m-2.625 0c0 3.075 -1.35 5.625 -2.925 5.625s-2.925 -2.55 -2.925 -5.625 1.35 -5.625 2.925 -5.625 2.925 2.55 2.925 5.625M13.35 12c0 3.3 -2.625 6 -5.925 6S1.5 15.3 1.5 12s2.625 -6 5.925 -6 5.925 2.7 5.925 6",
    fill: "currentColor"
  }
) });
export {
  r as M
};
